import { combineReducers } from 'redux'
import { routerReducer } from 'react-router-redux'
import config from './config'
import user from './user'
import order from './order'
import cart from './cart'
import quotation from './quotation'
import productTypes from './productTypes'
import connectorTypes from './connectorTypes'
import fiberTypes from './fiberTypes'
import cableTypes from './cableTypes'
import packagingTypes from './packagingTypes'

export default combineReducers({
    routing: routerReducer,
    user,
    config,
    order,
    productTypes,
    connectorTypes,
    fiberTypes,
    cableTypes,
    packagingTypes,
    cart,
    quotation
})


// WEBPACK FOOTER //
// ./../../htdocs/neutrik-opticalcon_fe/src/modules/index.js